import React, {Component} from "react";
import AuthService from "../../service/AuthService";
import AuthenticatedNav from "./AuthenticatedNav";
import UnauthenticatedNav from "./UnauthenticatedNav";

class TopNav extends Component {
    render() {
        if ((typeof this.props.authenticated === 'undefined' && AuthService.loggedIn()) || this.props.authenticated) {
            return (
                <AuthenticatedNav tab={this.props.tab} title={this.props.title}/>
            );
        } else {
            return (
                <UnauthenticatedNav tab={this.props.tab} title={this.props.title}/>
            );
        }
    }
}

TopNav.propTypes = {
    authenticated: React.PropTypes.bool,
    tab: React.PropTypes.string,
    title: React.PropTypes.string
};

export default TopNav;



// WEBPACK FOOTER //
// ./src/modules/common/nav/TopNav.js